import { useAuth } from "@/_core/hooks/useAuth";
import { getLoginUrl } from "@/const";
import { useLocation } from "wouter";
import { useEffect } from "react";

/**
 * Minimal onboarding entry point.
 * - If already logged in → redirect to /secrets
 * - If not → redirect to login, which will return them to /secrets
 */
export default function Start() {
  const { user, loading } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (loading) return;

    if (user) {
      setLocation("/secrets");
    } else {
      window.location.href = getLoginUrl("/secrets");
    }
  }, [user, loading, setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
}
